import { get, post } from '@/utils/request';

export const add_p_contract = (params) => {
  return post('/api/v1/platform/contract_rcode_sync_front', params);
};

export const batch_add_p_contract = (params) => {
  return post('/api/v1/platform/batch_add_contract_rcode_front', params);
};

export const contractsByPuser = (params) => {
  return get('/api/v1/platform/contracts_by_puser', params);
};
